import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MenuRoutingModule } from './menu-routing.module';
import { MenuComponent } from './menu.component';
import { MainPanelModule } from './main-panel/main-panel.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChartReportComponent } from './report/chart-report/chart-report.component';

@NgModule({
  declarations: [
    MenuComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,    
    MenuRoutingModule,
    ReactiveFormsModule,
    MainPanelModule,
  ],
  providers: [DatePipe],
  exports: [MenuComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class MenuModule {}
